import { getTheme, IStackItemTokens, IStackStyles, IStackTokens } from '@fluentui/react'
import { getThemeColors, getComponentColors, ThemeMode } from '../theme/colors';

const theme = getTheme();

export const rootStackStyles = (
  colorMode: ThemeMode,
  username = "default"
): IStackStyles => {
  return {
    root: {
      height: "calc(100vh - 48px)",
    },
  };
};

export const headerStackStyles: IStackStyles = {
    root: {
        height: 48,
        background: getComponentColors('header', 'light').background || '#2A5354'
    }
}

export const listItemsStackStyles: IStackStyles = {
    root: {
        padding: '10px'
    }
}

export const mainStackStyles = (colorMode: ThemeMode, username = 'default'): IStackStyles => {
    const colors = getThemeColors(username, colorMode);
    const componentColors = getComponentColors('chatPage', colorMode);
    
    return {
        root: {
            background: componentColors.background || colors.background,
        }
    }
}

export const sidebarStackStyles = (colorMode: ThemeMode, username = 'default'): IStackStyles => {
    const colors = getThemeColors(username, colorMode);
    
    return {
        root: {
            background: colors.background,
            boxShadow: theme.effects.elevation8,
            color: colors.text,
        },
    };
};

export const titleStackStyles: IStackStyles = {
    root: {
        alignItems: 'center',
        background: '#fafafa',
    }
}

export const stackPadding: IStackTokens = {
    padding: 10
}

export const stackGaps: IStackTokens = {
    childrenGap: 10
}

export const stackItemPadding: IStackItemTokens = {
    padding: 10
}

export const stackItemMargin: IStackItemTokens = {
    margin: 10
}

export const stackItemTokens: IStackItemTokens = {
    padding: 10
}

export const stackTokens: IStackTokens = {
    childrenGap: 10
}